import { app } from '@/config'
import { pages, app as app3 } from '@vue3/configs'
import constants from '@/constants'
import { shouldMakeSessionUpdateCall } from './common'
import store from '@/store'

const { EMAIL_VERIFICATION_DONE } = constants.companyRegistrationStatus

const registrationSteps = {
  REGISTRATION_TYPE: 'dealerType',
  DEALER_DATA: 'dealerInfo',
  PIC_DATA: 'picInfo',
  SUPPORTING_DATA: 'supportDocs',
  CREDIT_LIMIT_DATA: 'termsOfPayment'
}

const routeTo = (data, next, meta, routeName, fromPath) => {
  const initialRoute = routeName
  if (!data.emailVerified) {
    routeName = app.routerName.verifyEmail
  }
  else if (data?.companyDetails?.companyRegistrationStatus === constants.companyRegistrationStatus.APPROVED) {
    if (meta.auth) {
      if (meta.notAllowedAfterRegistration) {
        routeName = app3.routerName.homePage
      } else if (meta.checkAccessFromConfig) {
        const isUserHasAccess = validateRouteAccessBasedOnConfig(meta.configName)
        if (!isUserHasAccess) {
          routeName = app3.routerName.homePage
        }
      } else {
        // does nothing - required
      }
    } else {
      routeName = app3.routerName.homePage
    }
  } else if (data?.companyDetails?.companyRegistrationStatus === constants.companyRegistrationStatus.APPROVAL_PENDING) {
    store.commit('setShowLoader', false)
    routeName = app3.routerName.login
  } else {
    const isEmailVarificationCompleted = data?.registrationStatus === EMAIL_VERIFICATION_DONE
    const hasNoCurrentCompanyInfo = !Object.keys(data?.companyDetails || {}).length
    const hasMappedTenants = data?.tenantDetailsDTOS?.length
    const isUserLoggedInButTenantNotSelected = isEmailVarificationCompleted && hasNoCurrentCompanyInfo && hasMappedTenants
    if (isUserLoggedInButTenantNotSelected) {
      store.commit('setShowLoader', false)
      routeName = app3.routerName.login
    } else {
      const inProgressStep = data?.companyDetails?.registrationNextStep || data?.registrationNextStep
      if (!inProgressStep || !registrationSteps[inProgressStep]) {
        routeName = registrationSteps.REGISTRATION_TYPE
      } else {
        routeName = registrationSteps[inProgressStep]
      }
    }
  }
  if (initialRoute === routeName) {
    store.commit('setHideHeaderNavigation', meta.hideHeaderNavigation)
    store.commit('setShowLoader', false)
    next()
    return
  }
  if (routeName === fromPath) {
    store.commit('setShowLoader', false)
  }
  store.commit('setHideHeaderNavigation', true)
  store.commit('setShowLoader', false)
  if (routeName === app3.routerName.homePage) {
    next({ path: pages.homePage })
  } else if (routeName === app3.routerName.login) {
    next({ path: pages.login })
  } else {
    next({ name: routeName })
  }
}

const handleAuthenticatedRoute = (user, meta, next, nextPath, fromPath) => {
  if (meta.auth) {
    routeTo(user, next, meta, nextPath, fromPath)
  } else if (nextPath === app.routerName.verifyEmailWithId || nextPath === app.routerName.resetPassword) {
    const hideHeaderNavigation = store._vm['commonStore/getHideHeaderNavigation']
    !hideHeaderNavigation && store.commit('setHideHeaderNavigation', true)
    store.commit('setShowLoader', false)
    next()
  } else {
    routeTo(user, next, meta, nextPath, fromPath)
  }
}

const handleNotAuthenticatedRoute = (meta, next) => {
  const hideHeaderNavigation = store._vm['commonStore/getHideHeaderNavigation']
  !hideHeaderNavigation && store.commit('setHideHeaderNavigation', true)
  if (meta.auth) {
    next({ name: app3.routerName.landingPage })
  } else {
    store.commit('setShowLoader', false)
    next()
  }
}

export function userCheck (next, nextPath, fromPath, meta) {
  store.commit('setShowLoader', true)
  const isUserFetchFinished = store._vm['getIsUserFetchFinished']
  if (nextPath === app3.routerName.termsAndCondition) {
    store.commit('setShowLoader', false)
    next()
    return
  }
  if (!isUserFetchFinished) {
    setTimeout(() => {
      userCheck(next, nextPath, fromPath, meta)
    }, 400)
    return
  }
  const isLoggedIn = store._vm['getIsLoggedIn']
  if (isLoggedIn) {
    invokeSessionUpdatePerDayOnce()
    const userDetails = store._vm['getUserDetails']
    handleAuthenticatedRoute(userDetails, meta, next, nextPath, fromPath)
  } else {
    handleNotAuthenticatedRoute(meta, next)
  }
}

export function setAuthError (errorCode) {
  store.commit('setErrorCode', errorCode)
}

const validateRouteAccessBasedOnConfig = (configName) => {
  const isAppConfigFetched = store._vm['getIsAppConfigFetched']
  if (isAppConfigFetched) {
    const appConfig = store._vm['getAppConfigs']
    const configValue = appConfig?.[configName]
    const whitelistedUsers = appConfig?.whitelistedUsers || []
    const isFeatureEnabled = configValue?.isEnabled
    if (!isFeatureEnabled) { return false }
    const isOnlyForWhitelistedUsers = configValue?.isOnlyForWhitelistedUsers
    if (!isOnlyForWhitelistedUsers) { return true }
    const userDetails = store._vm['getUserDetails']
    return whitelistedUsers.includes(userDetails?.email)
  } else {
    const query = {
      id: 'applereseller.ui.config',
      requestId: 'apple-reseller-ui',
      clientId: 'apple-reseller-ui',
      storeId: '10001',
      channelId: store._vm['commonStore/getIsMobile'] ? 'mobile' : 'web'
    }
    store.dispatch('GET_APP_CONFIGURATION', {
      query,
      success: () => validateRouteAccessBasedOnConfig(configName)
    })
  }
}

const invokeSessionUpdatePerDayOnce = () => {
  if (shouldMakeSessionUpdateCall()) {
    store.dispatch('UPDATE_SESSION', {})
  }
}

export const checkLoginStatusAndInvokeSessionUpdate = () => {
  const isLoggedIn = store._vm['getIsLoggedIn']
  if (isLoggedIn) {
    invokeSessionUpdatePerDayOnce()
  }
}

